import React, {ReactNode} from "react";
import {FormProvider, useForm} from "react-hook-form";

import {BUDGET_DEFAULT} from "../../constants/filters_defaults";
import {ISearchFiltersFormValues} from "../../types/ISearchFiltersFormValues";
import {BudgetFieldsNames} from "./FilterBudget";

interface IProps {
    children: ReactNode;
    defaultValues: ISearchFiltersFormValues;
}

export const FilterForm = (props: IProps) => {
    const formMethods = useForm({
        defaultValues: {
            ...props.defaultValues,
            [BudgetFieldsNames.TOTAL]: props.defaultValues.price?.upper || BUDGET_DEFAULT,
            [BudgetFieldsNames.CREDIT]: props.defaultValues.instalment || 0,
            [BudgetFieldsNames.RADIO]: props.defaultValues.instalment ? "monthly" : "total"
        }
    });

    return <FormProvider {...formMethods}>{props.children}</FormProvider>;
};
import React, {ReactNode} from "react";
import {FormProvider, useForm} from "react-hook-form";

import {BUDGET_DEFAULT} from "../../constants/filters_defaults";
import {ISearchFiltersFormValues} from "../../types/ISearchFiltersFormValues";
import {BudgetFieldsNames} from "./FilterBudget";

interface IProps {
    children: ReactNode;
    defaultValues: ISearchFiltersFormValues;
}

export const FilterForm = (props: IProps) => {
    const formMethods = useForm({
        defaultValues: {
            ...props.defaultValues,
            [BudgetFieldsNames.TOTAL]: props.defaultValues.price?.upper || BUDGET_DEFAULT,
            [BudgetFieldsNames.CREDIT]: props.defaultValues.instalment || 0,
            [BudgetFieldsNames.RADIO]: props.defaultValues.instalment ? "monthly" : "total"
        }
    });

    return <FormProvider {...formMethods}>{props.children}</FormProvider>;
};
